export const ENGAGEMENT_GET_EMAIL_DRAFT_DATA_BEGIN = 'ENGAGEMENT_GET_EMAIL_DRAFT_DATA_BEGIN';
export const ENGAGEMENT_GET_EMAIL_DRAFT_DATA_SUCCESS = 'ENGAGEMENT_GET_EMAIL_DRAFT_DATA_SUCCESS';
export const ENGAGEMENT_GET_EMAIL_DRAFT_DATA_FAILURE = 'ENGAGEMENT_GET_EMAIL_DRAFT_DATA_FAILURE';
export const ENGAGEMENT_GET_EMAIL_DRAFT_DATA_DISMISS_ERROR = 'ENGAGEMENT_GET_EMAIL_DRAFT_DATA_DISMISS_ERROR';
export const ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_BEGIN = 'ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_BEGIN';
export const ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_SUCCESS = 'ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_SUCCESS';
export const ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_FAILURE = 'ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_FAILURE';
export const ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_DISMISS_ERROR = 'ENGAGEMENT_CREATE_PERSONALIZED_COMMENT_DISMISS_ERROR';
export const ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_BEGIN = 'ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_BEGIN';
export const ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_SUCCESS = 'ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_SUCCESS';
export const ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_FAILURE = 'ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_FAILURE';
export const ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_DISMISS_ERROR = 'ENGAGEMENT_UPDATE_PERSONALIZED_COMMENT_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/engagement/redux/constants.js